"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IForgotPasswordResult = exports.IOrgUserSecurity = exports.UserNotifyWebsocketMessage = exports.UserNotifyType = exports.IUserOrgs = exports.IResendInvite = exports.IUsersToInvite = exports.IExtendedUser = exports.UserCognitoRisk = exports.CreateUserBody = exports.IUser = exports.IOrgUser = exports.UserCognitoStatus = void 0;
const openapi_1 = require("../../../openapi");
const app_product_1 = require("./app-product");
const organization_1 = require("./organization");
var UserCognitoStatus;
(function (UserCognitoStatus) {
    UserCognitoStatus["UNCONFIRMED"] = "UNCONFIRMED";
    UserCognitoStatus["CONFIRMED"] = "CONFIRMED";
    UserCognitoStatus["ARCHIVED"] = "ARCHIVED";
    UserCognitoStatus["COMPROMISED"] = "COMPROMISED";
    UserCognitoStatus["UNKNOWN"] = "UNKNOWN";
    UserCognitoStatus["RESET_REQUIRED"] = "RESET_REQUIRED";
    UserCognitoStatus["FORCE_CHANGE_PASSWORD"] = "FORCE_CHANGE_PASSWORD";
})(UserCognitoStatus = exports.UserCognitoStatus || (exports.UserCognitoStatus = {}));
class IOrgUser {
    orgKey;
    userId;
    // TODO - the API is returning a number, not a string
    warehouseManagerUserId;
    tplUserId;
    integrationManagerUserId;
    orderManagerUserId;
    defaultAppName;
    jobTitle;
    role;
    productAccess;
    security;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IOrgUser.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IOrgUser.prototype, "userId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'integer' })
    // TODO - the API is returning a number, not a string
], IOrgUser.prototype, "warehouseManagerUserId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgUser.prototype, "tplUserId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgUser.prototype, "integrationManagerUserId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgUser.prototype, "orderManagerUserId", void 0);
__decorate([
    (0, openapi_1.Schema)({
        type: 'string',
        enum: Object.values(app_product_1.AppName),
        description: 'What App the user will be redirected to when they log in',
    })
], IOrgUser.prototype, "defaultAppName", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgUser.prototype, "jobTitle", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'string',
        format: 'uuid',
        description: "ID of the user's role",
    })
], IOrgUser.prototype, "role", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => app_product_1.IProductAccess)
], IOrgUser.prototype, "productAccess", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => IOrgUserSecurity)
], IOrgUser.prototype, "security", void 0);
exports.IOrgUser = IOrgUser;
class IUser extends IOrgUser {
    id;
    email;
    firstName;
    lastName;
    defaultOrgKey;
    status;
    isSuperUser;
    image;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IUser.prototype, "id", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'email' })
], IUser.prototype, "email", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IUser.prototype, "firstName", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IUser.prototype, "lastName", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'string',
        format: 'uuid',
        description: 'Organization selected when the user logs in',
    })
], IUser.prototype, "defaultOrgKey", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(UserCognitoStatus) })
], IUser.prototype, "status", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean' })
], IUser.prototype, "isSuperUser", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uri' })
], IUser.prototype, "image", void 0);
exports.IUser = IUser;
class CreateUserBody extends IUser {
    tempPassword;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'string',
        description: 'Custom temporary password. If not specified, a random password will be generated.',
    })
], CreateUserBody.prototype, "tempPassword", void 0);
exports.CreateUserBody = CreateUserBody;
class UserCognitoRisk {
    CompromisedCredentialsDetected;
    RiskDecision;
    RiskLevel;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], UserCognitoRisk.prototype, "CompromisedCredentialsDetected", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], UserCognitoRisk.prototype, "RiskDecision", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], UserCognitoRisk.prototype, "RiskLevel", void 0);
exports.UserCognitoRisk = UserCognitoRisk;
class IExtendedUser {
    id;
    email;
    firstName;
    lastName;
    jobTitle;
    image;
    isSuperUser;
    orgs;
    contextOrgApps;
    defaultOrgKey;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IExtendedUser.prototype, "id", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'email' })
], IExtendedUser.prototype, "email", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IExtendedUser.prototype, "firstName", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IExtendedUser.prototype, "lastName", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IExtendedUser.prototype, "jobTitle", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uri' })
], IExtendedUser.prototype, "image", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'boolean' })
], IExtendedUser.prototype, "isSuperUser", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IUserOrgs) })
], IExtendedUser.prototype, "orgs", void 0);
__decorate([
    (0, openapi_1.Schema)(() => app_product_1.IProductAccess)
], IExtendedUser.prototype, "contextOrgApps", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtendedUser.prototype, "defaultOrgKey", void 0);
exports.IExtendedUser = IExtendedUser;
class IUsersToInvite {
    emails;
    jobTitle;
    role;
    productAccess;
    tempPassword;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: { type: 'string', format: 'email' } })
], IUsersToInvite.prototype, "emails", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IUsersToInvite.prototype, "jobTitle", void 0);
__decorate([
    (0, openapi_1.Schema)({
        type: 'string',
        format: 'uuid',
        description: "ID of the new users' role",
    })
], IUsersToInvite.prototype, "role", void 0);
__decorate([
    (0, openapi_1.Schema)(() => app_product_1.IProductAccess)
], IUsersToInvite.prototype, "productAccess", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IUsersToInvite.prototype, "tempPassword", void 0);
exports.IUsersToInvite = IUsersToInvite;
class IResendInvite {
    email;
    tempPassword;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'email' })
], IResendInvite.prototype, "email", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IResendInvite.prototype, "tempPassword", void 0);
exports.IResendInvite = IResendInvite;
class IUserOrgs {
    key;
    displayName;
    extensivId;
    logo;
    tplUserId;
    has3pl;
    role;
    isC2;
    security;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IUserOrgs.prototype, "key", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IUserOrgs.prototype, "displayName", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IUserOrgs.prototype, "extensivId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uri' })
], IUserOrgs.prototype, "logo", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'string',
        description: 'Usually HUB_CREATED, HUB_VERIFIED or an id',
    })
], IUserOrgs.prototype, "tplUserId", void 0);
__decorate([
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Whether or not this org has 3PL set up',
    })
], IUserOrgs.prototype, "has3pl", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IUserOrgs.prototype, "role", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean' })
], IUserOrgs.prototype, "isC2", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => organization_1.IOrgSecurity)
], IUserOrgs.prototype, "security", void 0);
exports.IUserOrgs = IUserOrgs;
var UserNotifyType;
(function (UserNotifyType) {
    UserNotifyType["ACTIVATEORG3W"] = "activateOrg3w";
    UserNotifyType["CREATEORG3W"] = "createOrg3w";
    UserNotifyType["ACTIVATEUSER3W"] = "activateUser3w";
    UserNotifyType["CREATEUSER3W"] = "createUser3w";
    UserNotifyType["ACTIVATEORGIM"] = "activateOrgIm";
    UserNotifyType["CREATEORGIM"] = "createOrgIm";
    UserNotifyType["ACTIVATEUSERIM"] = "activateUserIm";
    UserNotifyType["CREATEUSERIM"] = "createUserIm";
    UserNotifyType["ACTIVATEORGOM"] = "activateOrgOm";
    UserNotifyType["CREATEORGOM"] = "createOrgOm";
    UserNotifyType["ACTIVATEUSEROM"] = "activateUserOm";
    UserNotifyType["CREATEUSEROM"] = "createUserOm";
    UserNotifyType["ACTIVATEORGWM"] = "activateOrgWm";
    UserNotifyType["CREATEORGWM"] = "createOrgWm";
    UserNotifyType["ACTIVATEUSERWM"] = "activateUserWm";
    UserNotifyType["CREATEUSERWM"] = "createUserWm";
})(UserNotifyType = exports.UserNotifyType || (exports.UserNotifyType = {}));
class UserNotifyWebsocketMessage {
    type;
    description;
    originalEventId;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(UserNotifyType) })
], UserNotifyWebsocketMessage.prototype, "type", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], UserNotifyWebsocketMessage.prototype, "description", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid', description: 'ID from WMS' })
], UserNotifyWebsocketMessage.prototype, "originalEventId", void 0);
exports.UserNotifyWebsocketMessage = UserNotifyWebsocketMessage;
class IOrgUserSecurity {
    mfaEnabled;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'boolean' })
], IOrgUserSecurity.prototype, "mfaEnabled", void 0);
exports.IOrgUserSecurity = IOrgUserSecurity;
class IForgotPasswordResult {
    invitationResent;
}
__decorate([
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'An invitation e-mail was resent to the user',
    })
], IForgotPasswordResult.prototype, "invitationResent", void 0);
exports.IForgotPasswordResult = IForgotPasswordResult;
